import React from "react";
import { useLocation } from "react-router-dom";
import { Container } from "react-bootstrap";

const InnerBanner = ({ title }) => {
    const location = useLocation();

    const pageTitle = title || location.pathname.replace("/", "").replace(/_/g, " ").replace(/-/g, " ").toUpperCase();

    return (
        <section className="inner-banner-sec" style={{ backgroundImage: `url('/assets/images/topbg.jpg')`, }}>
            <Container>
                <div className="page-title-wrapper text-center">
                    <div className="col-md-12 col-sm-12 col-lg-12">
                        <div className="page-title-inner">
                            <h1>{pageTitle}</h1>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default InnerBanner;
